import { useTranslation } from 'react-i18next';

/**
 * Environment indicator for the sidebar rail.
 *
 * Extracted from the desktop header (MainLayout.tsx:104-111) which the hybrid
 * layout removes. Reads the same i18n keys so no label is lost.
 */
export function EnvironmentChip() {
  const { t } = useTranslation('navigation');

  return (
    <div
      className="flex items-center gap-1.5 rounded-lg border border-surface-border-light dark:border-surface-border-dark bg-surface-card-light dark:bg-surface-card-dark px-2.5 py-1.5 mb-3"
      title={`${t('header.systemEnvironment')} · ${t('header.productionCluster')}`}
    >
      <i
        className="w-1.5 h-1.5 rounded-full bg-state-ok-light dark:bg-state-ok-dark flex-shrink-0"
        aria-hidden="true"
      />
      <div className="flex flex-col min-w-0 leading-none">
        <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-text-subtle-light dark:text-text-subtle-dark truncate">
          {t('header.systemEnvironment')}
        </span>
        <span className="text-[10.5px] font-semibold text-slate-900 dark:text-white truncate mt-0.5">
          {t('header.productionCluster')}
        </span>
      </div>
    </div>
  );
}

export default EnvironmentChip;
